import {
    FETCH_CARS,
    FETCH_CARS_SUCCESS,
    FETCH_CARS_FAILED,
    EDIT_CAR
  } from "../store/types";
  import store from '../store/store';
  import { firebase } from '../config/configureFirebase';
  import { onValue, update, set, child, remove, push, get } from "firebase/database";
  import { uploadBytesResumable, getDownloadURL } from "firebase/storage";
  import base64 from 'react-native-base64';
  import AccessKey from '../other/AccessKey';

  // Normaliza placa no cliente (igual ao servidor): maiúsculas + só alfanumérico.
  const normPlate = (v) => (v ? String(v).replace(/[^a-zA-Z0-9]/g, '').toUpperCase() : '');

  // Reserva atômica da placa via Cloud Function (índice unique_plate).
  // Retorna { success } ou { success:false, error:'plate_already_exists' | ... }.
  const requestUpdateVehiclePlate = async (carId, placa) => {
    const { config } = firebase;
    const projectId = config.projectId;
    const url = `https://us-central1-${projectId}.cloudfunctions.net/update_vehicle_plate`;
    try {
      const response = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          "Authorization": "Basic " + base64.encode(projectId + ":" + AccessKey)
        },
        body: JSON.stringify({ carId, placa })
      });
      const result = await response.json().catch(() => ({}));
      if (!response.ok || result.error) {
        return { success: false, error: result.error || `http_${response.status}` };
      }
      return { success: true };
    } catch (e) {
      return { success: false, error: 'network_error' };
    }
  };

  // Busca o carro do motorista para exibir placa/cor. A fonte da verdade é o
  // cadastro do carro (nó `cars`), não o snapshot copiado para o perfil/booking.
  // Prefere o carro exato referenciado pelo booking (mesma car_image); na falta,
  // usa o carro ativo mais recente.
  export const getDriverActiveCar = async (uid, carImage) => {
    if (!uid) return null;
    const { carsRef } = firebase;
    const snap = await get(carsRef(uid, 'driver'));
    if (!snap.exists()) return null;
    const data = snap.val();
    const cars = Object.keys(data).map((id) => ({ id, ...data[id] }));
    let match = carImage ? cars.find((c) => c.car_image === carImage) : null;
    if (!match) {
      match = cars
        .filter((c) => c.active)
        .sort((a, b) => (b.createdAt || 0) - (a.createdAt || 0))[0] || null;
    }
    return match;
  };

  export const fetchCars = () => (dispatch) => {
  
    const {
        carsRef
    } = firebase;
  
    dispatch({
      type: FETCH_CARS,
      payload: null
    });

    const userInfo = store.getState().auth.profile;

    onValue(carsRef(userInfo.uid, userInfo.usertype), snapshot => {
      if (snapshot.val()) {
        let data = snapshot.val();
        const arr = Object.keys(data).map(i => {
          data[i].id = i;
          return data[i]
        });
        dispatch({
          type: FETCH_CARS_SUCCESS,
          payload: arr
        });
      } else {
        dispatch({
          type: FETCH_CARS_FAILED,
          payload: store.getState().languagedata.defaultLanguage.no_cars
        });
      }
    });
  };
  
  export const editCar = (car, method) => async (dispatch) => {
    const {
      singleUserRef,
      carAddRef, 
      carEditRef,
      carImage
    } = firebase;
    dispatch({
      type: EDIT_CAR,
      payload: { method, car }
    });
    if (method === 'Add') {
        push(carAddRef, car);
    } else if (method === 'Delete') {
        remove(carEditRef(car.id));
    } else if (method === 'UpdateImage') {
      await uploadBytesResumable(carImage(car.id),car.car_image);
      let image = await getDownloadURL(carImage(car.id));
      let data = car;
      data.car_image = image;
      set(carEditRef(car.id), data);
      if(car.active && car.driver){
        update(singleUserRef(car.driver), {
          updateAt: new Date().getTime(),
          car_image: image
        });
      }   
    }
     else {
        set(carEditRef(car.id),car);
    }
  }

  // editCar com unicidade de PLACA (índice unique_plate). Use nas telas de cadastro/edição
  // de veículo. Retorna { success, id? } ou { success:false, error:'plate_already_exists' }.
  export const editCarUnique = (car, method) => async (dispatch) => {
    const { carAddRef, carEditRef } = firebase;

    if (method === 'Add') {
      const carId = push(carAddRef).key;
      const placa = car.placa ? String(car.placa) : '';
      if (placa) {
        const claim = await requestUpdateVehiclePlate(carId, placa);
        if (claim.error === 'plate_already_exists') {
          return { success: false, error: 'plate_already_exists' };
        }
      }
      const toSave = { ...car };
      const norm = normPlate(car.placa);
      if (norm) toSave.placa = norm;
      delete toSave.tableData;
      set(child(carAddRef, carId), toSave);
      dispatch({ type: EDIT_CAR, payload: { method, car: toSave } });
      return { success: true, id: carId };
    }

    // Update
    const placa = car.placa ? String(car.placa) : '';
    if (placa) {
      const claim = await requestUpdateVehiclePlate(car.id, placa);
      if (claim.error === 'plate_already_exists') {
        return { success: false, error: 'plate_already_exists' };
      }
    }
    const toSave = { ...car };
    const norm = normPlate(car.placa);
    if (norm) toSave.placa = norm;
    delete toSave.tableData;
    set(carEditRef(toSave.id), toSave);
    dispatch({ type: EDIT_CAR, payload: { method, car: toSave } });
    return { success: true };
  }

  export const updateUserCarWithImage = (newData, blob) => async (dispatch) => {
    const {
      auth,
      carAddRef,
      singleUserRef,
      carImage
    } = firebase;

    var carId = push(carAddRef).key;

    // Reserva atômica da placa antes de subir imagem/gravar. Só bloqueia em duplicidade real.
    const placa = newData.placa ? String(newData.placa) : '';
    if (placa) {
      const claim = await requestUpdateVehiclePlate(carId, placa);
      if (claim.error === 'plate_already_exists') {
        return { success: false, error: 'plate_already_exists' };
      }
    }
    const norm = normPlate(newData.placa);
    if (norm) newData.placa = norm;

    try {
      await uploadBytesResumable(carImage(carId), blob);
      if (blob.close) blob.close();
      const url = await getDownloadURL(carImage(carId));
      newData.car_image = url;
      await set(child(carAddRef, carId), newData);
      if (newData.active) {
        let updateData = {
          carType: newData.carType,
          vehicleNumber: newData.vehicleNumber,
          vehicleMake: newData.vehicleMake,
          vehicleModel: newData.vehicleModel,
          other_info: newData.other_info ? newData.other_info : "",
          car_image: url,
          carApproved: newData.approved,
          renavam: newData.renavam ? newData.renavam : "",
          placa: newData.placa ? newData.placa : "",
          vehicleColor: newData.vehicleColor ? newData.vehicleColor : "",
          crlve: newData.crlve ? newData.crlve : "",
          version: newData.version ? newData.version : "",
          manufactureYear: newData.manufactureYear ? newData.manufactureYear : "",
          city: newData.city ? newData.city : "",
          capacity: newData.capacity ? newData.capacity : "",
          chassis: newData.chassis ? newData.chassis : "",
          state: newData.state ? newData.state : "",
          fuel: newData.fuel ? newData.fuel : "",
          bodywork: newData.bodywork ? newData.bodywork : "",
          vehicleType: newData.vehicleType ? newData.vehicleType : "",
          wheelType: newData.wheelType ? newData.wheelType : "",
          updateAt: new Date().getTime()
        };
        update(singleUserRef(auth.currentUser.uid), updateData);
      }
      return { success: true, id: carId };
    } catch (e) {
      return { success: false, error: 'upload_error' };
    }
  };